import { Person } from '../../../interfaces/person';

function findPersonInListFromPersonId(
  players: Person[],
  personId: number | string | undefined | null,
): Person | undefined {
  return players.find((person: Person) => person.personId === personId);
}

export default findPersonInListFromPersonId;
